module.exports = __webpack_public_path__ + "img/coachella.d00002f0.svg";